import React from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";

const CustomBarChart = ({ chartData, height = 375, onBarClick }) => {
  const { series, categories } = chartData;

  const hasData = series.some((s) => s.data.some((value) => value > 0));

  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: { show: false },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          if (onBarClick) {
            onBarClick(config.dataPointIndex);
          }
        },
      },
    },
    xaxis: {
      categories,
      labels: { style: { fontSize: "12px" } },
    },
    yaxis: {
      title: { text: "Meal Count" },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "40%",
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => `${val} meals`,
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
    },

    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    colors: ["#A3E7C1", "#2A85FF", "#EEA53E"], // Colors for Self, Guests, and Contract
    noData: {
      text: "No data to display",
      align: "center",
      verticalAlign: "middle",
      style: {
        color: "#666",
        fontSize: "16px",
      },
    },
  };

  return (
    <Chart
      options={options}
      series={hasData ? series : []} // If no data, pass an empty array
      type="bar"
      height={height}
    />
  );
};

CustomBarChart.propTypes = {
  chartData: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.string).isRequired,
    series: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        data: PropTypes.arrayOf(PropTypes.number).isRequired,
      })
    ).isRequired,
  }).isRequired,
  height: PropTypes.number,
  onBarClick: PropTypes.func,
};

export default CustomBarChart;
